import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { Backend } from '../_models/backend';
import { RouterConstants } from '../_models/router-constants';
import { Title } from '@angular/platform-browser';
import BoardLoginRequest = Backend.BoardLoginRequest;

@Component({
  selector: 'app-register-board',
  templateUrl: './register-board.component.html',
  styleUrls: ['./register-board.component.scss']
})
export class RegisterBoardComponent implements OnInit {

  boardRequest: BoardLoginRequest = {licenceCode: ''};

  constructor(private titleService: Title, private route: ActivatedRoute, private router: Router, private authService: AuthService) {
    this.titleService.setTitle('SEOS Board Register');

    // redirect to board if already registrated
    if (this.authService.currentUserValue) {
      this.router.navigate(['/' + RouterConstants.BOARD], {replaceUrl: true});
    }
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.register(this.boardRequest);
  }

  private register(boardRequest: BoardLoginRequest): void {
    this.authService.registerBoard(boardRequest)
      .pipe(first())
      .subscribe({
        next: () => {
          // get return url from route parameters or default to '/'
          const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
          this.router.navigate([returnUrl], {replaceUrl: true});
        }
      });
  }
}
